const validate = {
  rules: {
    titulo: {
      required: true,
    },
    url: {
      required: true,
    },
    tipo_projeto_id: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
    url: "A url é obrigatória.",
    tipo_projeto_id: "Tipo de projeto é obrigatório.",
  },
};

export default validate;
